import * as SearchRequestActions from '../actions/search-request';
import { SearchRequest } from '../../shared/models/search-request.model';

export type State = SearchRequest[];

export const InitialState: State = [];

export function reducer(state: State = InitialState, action: SearchRequestActions.All): State {
	switch (action.type) {
		case SearchRequestActions.LOAD_SEARCH_REQUEST_SUCCESS:
			return action.payload;

		case SearchRequestActions.SAVE_SEARCH_REQUEST_SUCCESS:
			return state.concat(action.payload);

		case SearchRequestActions.DELETE_SEARCH_REQUEST_SUCCESS:
			return state.filter((s: SearchRequest) => s._id !== action.payload._id);

		case SearchRequestActions.RENAME_SEARCH_REQUEST_SUCCESS:
			return state.map(s => {
				if (s._id === action.payload._id) {
					return action.payload;
				}

				return s;
			});

		default:
			return state;
	}
}

export const searchRequest = (s: State): SearchRequest[] => s;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/search-request.ts